module.exports = __webpack_public_path__ + "img/sword-space.63929d79.png";